import type MiniStatementRepository from "@/core/customers/repositories/MiniStatementRepository";
import type { AccountMovement, AccountMovementSense } from "@/core/customers/entities/AccountMovement";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import { getMiniStatementUrl } from "../../api/accountsEndpoints/accountsEndpoints";

// Reflets exacts de AccountMovementResponse cote backend.
interface ApiAccountMovement {
  date: string;
  label: string;
  amount: number;
  sense: AccountMovementSense;
  balanceAfter: number;
}

function mapDto(dto: ApiAccountMovement): AccountMovement {
  return {
    date: dto.date,
    label: dto.label,
    amount: dto.amount,
    sense: dto.sense,
    balanceAfter: dto.balanceAfter,
  };
}

export default class MiniStatementRepositoryBackend implements MiniStatementRepository {
  constructor(private readonly httpClient: HttpClient) {}

  getMiniStatement(
    clientId: string,
    accountNumber: string,
    limit?: number,
  ): Promise<RepositoryResult<AccountMovement[]>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<ApiAccountMovement[]>>({
          url: getMiniStatementUrl(clientId, accountNumber, limit),
          withAuth: true,
        }),
      (movements) => movements.map(mapDto),
    );
  }
}
